export default "__VITE_PUBLIC_ASSET__40b805dd__"